import React from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  CountrycodeSelect,
  TailwindToaster,
  GmapsComponent,
  PropertyThumbnail,
  Pagination,
  numberToINR,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import CryptoJS from "crypto-js";
import Multiselect from "multiselect-react-dropdown";

import { downloadBlobFile, uploadBlobToContainer } from "../../api/azure";

// import { Combobox } from "@headlessui/react";

import axios from "../../api/axios";

const EnquiryCreate = () => {
  const state = useSelector((state) => state.UserReducer);
  const addressBookUrl = "/addressbook/options";
  const createUrl = "/enquiry";
  const serviceOptionUrl = "/service";
  const subServiceOptionUrl = "/subservice";
  const propertyOptionUrl = "/propertyoption";
  const subPropertyOptionUrl = "/subpropertyoption";
  const navigate = useNavigate();
  const blobContainerName = "propertyimages";
  const activeCRMUrl = "/user/active";
  const propertyLocationUrl = "/pifLocation";
  const propertyInformationUrl = "/pif";

  const [propertyOption, setPropertyOption] = React.useState("");
  const [subPropertyOption, setSubPropertyOption] = React.useState("");
  const [pifLocations, setPIFLocations] = React.useState([]);
  const [approvalStatus, setapprovalStatus] = React.useState("");
  const [areaUnits, setareaUnits] = React.useState(0);
  const [minPrice, setminPrice] = React.useState(0);
  const [maxPrice, setmaxPrice] = React.useState(9999999999999);
  const [facing, setfacing] = React.useState("");
  const [refreshPropertyData, setRefreshPropertyData] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(20);
  const [propertyInformationData, setPropertyData] = React.useState([]);

  const [pifLocationsSelectedData, setPifLocationsSelectedData] =
    React.useState([]);

  const filterProperties = () => {
    setRefreshPropertyData(0);
    setTotalRecords(0);
    const queryOptions = {
      location: "",
      propertyOption,
      subPropertyOption,
      approvalStatus: approvalStatus,
      areaUnits,
      minPrice,
      maxPrice,
      facing,
      pifLocations,
    };
    try {
      axios
        .get(propertyInformationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            queryOptions,
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
          },
        })
        .then((response) => {
          // if (response?.data?.property?.length >= 0) {
          setPropertyData(response.data.property);
          // setPropertyServerData(response.data.property);
          if (response.data.propertyInformationCount?.length > 0) {
            setTotalRecords(
              response.data.propertyInformationCount[0].propertyInformationCnt,
            );
            setTotalPages(
              Math.ceil(
                response.data.propertyInformationCount[0]
                  .propertyInformationCnt / recordsPerPage,
              ),
            );
          } else {
            setTotalRecords(0);
            setTotalPages(0);
          }
          setRefreshPropertyData(1);
          // }
        })
        .catch((err) => {
          toast.error("Something went wrong");
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [propertyLocationsData, setPropertyLocationsData] = React.useState([]);
  const getPropertyLocations = () => {
    try {
      axios
        .get(propertyLocationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.pifLocations?.length > 0) {
            setPropertyLocationsData(response.data.pifLocations);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [serviceOptionsData, setServiceOptionsData] = React.useState([]);
  const [subServiceOptionsData, setSubServiceOptionsData] = React.useState([
    { _id: undefined, name: "Select Service" },
  ]);
  const [requestLoading, setRequestLoading] = React.useState(false);
  const [propertyOptionsData, setPropertyOptionsData] = React.useState([]);
  const [subPropertyOptionsData, setSubPropertyOptionsData] = React.useState([
    { _id: undefined, name: "Select Property" },
  ]);
  const [subServiceLabel, setSubServiceLabel] = React.useState("");
  const [channel, setChannel] = React.useState("");

  const getServiceOptions = () => {
    try {
      axios
        .get(serviceOptionUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.services?.length > 0) {
            setServiceOptionsData(response.data.services);
            updateSubServiceOptions(response.data.services[0]._id);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const updateSubServiceOptions = (serviceId) => {
    try {
      axios
        .get(subServiceOptionUrl + "/" + serviceId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subservice?.length > 0) {
            setSubServiceOptionsData(response.data.subservice);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getPropertyOptions = () => {
    try {
      axios
        .get(propertyOptionUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.properties?.length > 0) {
            setPropertyOptionsData(response.data.properties);
            updateSubPropertyOptions(response.data.properties[0]._id);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const updateSubPropertyOptions = (propertyId) => {
    try {
      axios
        .get(subPropertyOptionUrl + "/" + propertyId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subPropertyOption?.length > 0) {
            setSubPropertyOptionsData(response.data.subPropertyOption);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [addressBookData, setAddressBookData] = React.useState([]);
  const [addressBookLoading, setAddressBookLoading] = React.useState(false);
  const getAddressBook = () => {
    setAddressBookLoading(true);
    try {
      axios
        .get(addressBookUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          setAddressBookLoading(false);
          if (response?.data?.addressBook?.length > 0) {
            setAddressBookData(response.data.addressBook);
          }
        })
        .catch((err) => {
          setAddressBookLoading(false);
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      setAddressBookLoading(false);
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [countryCodeDisabled, setCountryCodeDisabled] = React.useState(false);
  const [countryCodeValue, setCountryCodeValue] = React.useState("91");

  const updateExistingUserDetails = (addressBook) => {
    document.getElementById("prefix").value = addressBook.prefix;
    document.getElementById("prefix").disabled = true;
    document.getElementById("countryCode").disabled = true;
    document.getElementById("countryCode").value = addressBook.countryCode;
    document.getElementById("phoneNumber").value = addressBook.phoneNumber;
    document.getElementById("phoneNumber").readOnly = false;
    document.getElementById("firstName").value = addressBook.firstName;
    document.getElementById("firstName").readOnly = true;
    document.getElementById("lastName").value = addressBook.lastName
      ? addressBook.lastName
      : "";
    document.getElementById("lastName").readOnly = true;
    document.getElementById("customerType").value = addressBook.customerType;
    document.getElementById("crm").value = addressBook.crm?._id;
    document.getElementById("customerType").disabled = true;
    document.getElementById("crm").disabled = true;
  };
  const resetAddressBookFields = () => {
    document.getElementById("firstName").value = "";
    document.getElementById("firstName").readOnly = false;
    setCountryCodeDisabled(false);
    document.getElementById("countryCode").value = "91";
    document.getElementById("countryCode").disabled = false;
    // document.getElementById("phoneNumber").value = "";
    document.getElementById("phoneNumber").readOnly = false;
    document.getElementById("prefix").value = "Mr";
    document.getElementById("prefix").disabled = false;
    document.getElementById("lastName").value = "";
    document.getElementById("lastName").readOnly = false;
    document.getElementById("customerType").value = "Direct";
    document.getElementById("customerType").disabled = false;
    document.getElementById("crm").value = state.user._id;
    document.getElementById("crm").disabled = false;
  };

  const updateExistingUserDetailsWithMobile = (phoneNumber) => {
    var matchedIndex = -1;
    for (var i = 0; i < addressBookData.length; i++) {
      if (
        addressBookData[i].phoneNumber === phoneNumber &&
        addressBookData[i].countryCode === countryCodeValue
      ) {
        matchedIndex = i;
        break;
      }
    }
    if (matchedIndex >= 0) {
      const existingAddressBook = addressBookData[matchedIndex];
      // document.getElementById("existingAddressBooks").value = matchedIndex;
      updateExistingUserDetails(existingAddressBook);
    }
  };

  const [crmData, setCRMData] = React.useState([]);
  const getCRMOptions = () => {
    try {
      axios
        .get(activeCRMUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            setCRMData(response.data.users);
            setTimeout(() => {
              document.getElementById("crm").value = state.user._id;
            }, 500);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getAddressBook();
    getServiceOptions();
    getPropertyOptions();
    getCRMOptions();
    getPropertyLocations();
  }, []);

  const [leadType, setLeadType] = React.useState("Individual");
  const [prefix, setPrefix] = React.useState("Mr");
  const [customerType, setCustomerType] = React.useState("Direct");
  const [crm, setCRM] = React.useState(state.user._id);

  const [validCustomerType, setCustomerTypeValidity] = React.useState(true);
  const [validFirstName, setFirstNameValidity] = React.useState(true);
  const [validChannel, setChannelValidity] = React.useState(true);
  const [validReferenceName, setReferenceNameValidity] = React.useState(true);
  const [validWebsiteLink, setWebsiteLinkValidity] = React.useState(true);
  const [validLandExtent, setLandExtentValidity] = React.useState(true);
  const [validUnits, setUnitsValidity] = React.useState(true);
  const [validBudgetfactor, setBudgetFactorValidity] = React.useState(true);
  const [validPhoneNumber, setPhoneNumberValidity] = React.useState(true);
  const [referenceChannel, setReferenceChannel] = React.useState(false);
  const [websiteChannel, setWebsiteChannel] = React.useState(false);
  const [validCompanyName, setCompanyNameValidity] = React.useState(true);
  const [validCompanyAddress, setCompanyAddressValidity] = React.useState(true);
  const [validCompanyPhone, setCompanyPhoneValidity] = React.useState(true);
  const [validCountryCode, setCountryCodeValidity] = React.useState(true);

  const handleSubmit = (event) => {
    event.preventDefault();
    var canSubmit = true;
    const enquiryData = new FormData(event.target);

    setCustomerTypeValidity(true);
    setFirstNameValidity(true);
    setChannelValidity(true);
    setReferenceNameValidity(true);
    setWebsiteLinkValidity(true);
    setLandExtentValidity(true);
    setUnitsValidity(true);
    setBudgetFactorValidity(true);
    setPhoneNumberValidity(true);
    setCompanyNameValidity(true);
    setCompanyAddressValidity(true);
    setCompanyPhoneValidity(true);

    if (enquiryData.get("firstName") === "") {
      setFirstNameValidity(false);
      canSubmit = false;
    }

    if (enquiryData.get("channel") === "") {
      setChannelValidity(false);
      canSubmit = false;
    }

    if (
      enquiryData.get("leadType") === "Corporate" &&
      enquiryData.get("corporateLeadCompanyName") === ""
    ) {
      setCompanyNameValidity(false);
      canSubmit = false;
    }
    if (enquiryData.get("landExtent") < 0) {
      setLandExtentValidity(false);
      canSubmit = false;
    }
    if (countryCodeValue === "") {
      setCountryCodeValidity(false);
      canSubmit = false;
    }

    if (enquiryData.get("units") <= 0) {
      setUnitsValidity(false);
      canSubmit = false;
    }

    if (
      enquiryData.get("budget") !== "" &&
      enquiryData.get("budgetfactor") === ""
    ) {
      setBudgetFactorValidity(false);
      canSubmit = false;
    }

    if (
      enquiryData.get("channel") === "Reference" &&
      enquiryData.get("referenceName") === ""
    ) {
      setReferenceNameValidity(false);
      canSubmit = false;
    }

    if (
      enquiryData.get("channel") === "Reference" &&
      enquiryData.get("websiteLink") === ""
    ) {
      setWebsiteLinkValidity(false);
      canSubmit = false;
    }

    if (
      enquiryData.get("phoneNumber") === "" ||
      enquiryData.get("phoneNumber").length < 10
    ) {
      setPhoneNumberValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }
    setRequestLoading(true);

    const dataToSubmit = {
      prefix,
      customerType,
      crm,
      firstName: enquiryData.get("firstName"),
      lastName: enquiryData.get("lastName"),
      countryCode: countryCodeValue,
      phoneNumber: enquiryData.get("phoneNumber"),
      channel: enquiryData.get("channel"),
      referenceName: enquiryData.get("referenceName"),
      websiteLink: enquiryData.get("websiteLink"),
      serviceTypeId: enquiryData.get("serviceTypeId"),
      subServiceTypeId: enquiryData.get("subServiceTypeId"),
      propertyOptionId: enquiryData.get("propertyOptionId"),
      subPropertyOptionId: enquiryData.get("subPropertyOptionId"),
      description: "",
      serviceInformation: enquiryData.get("serviceInformation"),
      backgroundInformation: enquiryData.get("backgroundInformation"),
      purposeOfBuying: enquiryData.get("purposeOfBuying"),
      landExtent: enquiryData.get("landExtent"),
      units: enquiryData.get("units"),
      leadType: enquiryData.get("leadType"),
      location: enquiryData.get("location"),
      budget: enquiryData.get("budget") * enquiryData.get("budgetfactor"),
      bhk: enquiryData.get("bhk"),
      corporateLeadCompanyName: enquiryData.get("corporateLeadCompanyName"),
      corporateLeadDesignation: enquiryData.get("corporateLeadDesignation"),
      corporateLeadCompanyAddress: enquiryData.get(
        "corporateLeadCompanyAddress",
      ),
      corporateLeadPhone: enquiryData.get("corporateLeadPhone"),
      pifLat: enquiryData.get("latitude"),
      pifLng: enquiryData.get("longitude"),
      pifFrontage: enquiryData.get("frontage"),
      pifFacing: enquiryData.get("facing"),
      pifParkingAvailable: parkingAvailable,
      pifPropertyImageAttachments: propertyImageAttachments,
      pifBuildingFloors: enquiryData.get("buildingFloors"),
      pifLocations,
    };

    try {
      axios
        .post(createUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setTimeout(() => {
              window.scrollTo(0, 0);
              navigate(-1);
            }, 1000);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
    }
  };

  const [serviceTypeValue, setServiceTypeValue] = React.useState("");
  const [subServiceTypeValue, setSubServiceTypeValue] = React.useState("");
  const [markerCoordinates, setMarkerCoordinates] = React.useState({
    lat: 11.0083592,
    lng: 76.9746159,
  });
  const [parkingAvailable, setparkingAvailable] = React.useState(false);
  const [propertyImageAttachments, setPropertyImageAttachments] =
    React.useState([]);

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
  };
  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
    setTotalPages(
      Math.ceil(propertyInformationData?.length / targetRecordsPerPage),
    );
  };
  const uploadPropertyImage = async (files) => {
    setRequestLoading(true);
    toast.success("Uploading images to Storage");
    let propertyImages = [];
    for (let i = 0; i < files.length; i++) {
      const fileExtension = files[i].name.split(".")[1];
      const blobName =
        CryptoJS.AES.encrypt(
          files[i].name + Date.now().toString(),
          process.env.REACT_APP_CIPHER_CODE,
        )
          .toString()
          .replace(/[^a-zA-Z0-9_]/g, "") + ".crypt";
      // + fileExtension;
      try {
        const uploadBlobResult = await uploadBlobToContainer(
          blobContainerName,
          blobName,
          files[i],
        );
        if (uploadBlobResult.status === "success") {
          const blobItem = {
            originalname: files[i].name,
            size: files[i].size,
            blobContainer: blobContainerName,
            blobName,
            mimetype: files[i].type,
          };
          propertyImages.push(blobItem);
        }
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      }
      setRequestLoading(false);
    }
    if (propertyImageAttachments.length > 0)
      setPropertyImageAttachments(
        propertyImageAttachments.concat(propertyImages),
      );
    else setPropertyImageAttachments(propertyImages);
  };
  const removePropertyImageAttachments = (serverfilename) => {
    const filteredAttachments = propertyImageAttachments.filter((item) => {
      return item.blobName !== serverfilename;
    });
    setPropertyImageAttachments(filteredAttachments);
  };

  const updatedMarkerPosition = (coordinates) => {
    setMarkerCoordinates(coordinates);
  };
  React.useEffect(() => {
    setMarkerCoordinates({
      lat: 11.0083592,
      lng: 76.9746159,
    });
  }, [subServiceTypeValue]);
  React.useEffect(() => {
    if (
      (serviceTypeValue?.toLowerCase().includes("brokerage") &&
        subServiceTypeValue?.toLowerCase().includes("sell")) ||
      (serviceTypeValue?.toLowerCase().includes("rental") &&
        subServiceTypeValue?.toLowerCase().includes("landlord"))
    )
      setTimeout(() => {
        document.getElementById("longitude").value = markerCoordinates.lng;
        document.getElementById("latitude").value = markerCoordinates.lat;
      }, 800);
  }, [markerCoordinates]);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <form
                  action='#'
                  method='POST'
                  noValidate
                  onSubmit={(event) => {
                    handleSubmit(event);
                  }}>
                  <TailwindToaster />
                  <div className='shadow overflow-hidden sm:rounded-md'>
                    <div className='px-4 py-5 bg-dark-50 sm:p-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Create Enquiry Form
                          </h2>
                        </div>
                      </div>
                      <div className='mt-4 sm:mt-4 grid grid-cols-12 gap-4'>
                        <div className='col-span-5 sm:col-span-1'>
                          <label
                            htmlFor='countryCode'
                            className='block text-sm font-medium text-gray-700 '>
                            Country Code*
                          </label>
                          <input
                            type='tel'
                            name='countryCode'
                            id='countryCode'
                            maxLength='5'
                            value={countryCodeValue}
                            className={`mt-1 ${
                              !validCountryCode
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                            onChange={(e) => {
                              setCountryCodeValue(e.target.value);
                            }}
                          />
                        </div>
                        <div className='col-span-7 sm:col-span-2'>
                          <label
                            htmlFor='phoneNumber'
                            className={`block text-sm font-medium ${
                              !validPhoneNumber
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Mobile#*
                          </label>
                          {addressBookLoading ? (
                            <span className='mt-1 block w-full py-0  sm:text-sm cursor-wait'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-full bg-gray-100 h-10 rounded-md '></div>
                              </div>
                            </span>
                          ) : (
                            <input
                              type='tel'
                              name='phoneNumber'
                              id='phoneNumber'
                              maxLength='10'
                              onChange={(e) => {
                                if (e.target.value.length === 10) {
                                  updateExistingUserDetailsWithMobile(
                                    e.target.value,
                                  );
                                } else {
                                  resetAddressBookFields();
                                }
                              }}
                              className={`mt-1 ${
                                !validPhoneNumber
                                  ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                  : "focus:ring-yellow-2 focus:border-yellow-2"
                              }  block w-full shadow-sm sm:text-sm  rounded-md read-only:bg-gray-100 read-only:opacity-50`}
                            />
                          )}

                          {!validPhoneNumber && (
                            <p className='text-red-600 text-sm'>
                              Phone Number invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-4 sm:col-span-1'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700'>
                            Prefix*
                          </label>
                          <select
                            id='prefix'
                            name='prefix'
                            onChange={(e) => {
                              setPrefix(e.target.value);
                            }}
                            className='mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm disabled:bg-gray-100 disabled:opacity-50 '>
                            <option value='Mr'>Mr</option>
                            <option value='Mrs'>Mrs</option>
                            <option value='Ms'>Ms</option>
                            <option value='Dr'>Dr</option>
                            <option value='Er'>Er</option>
                          </select>
                        </div>
                        <div className='col-span-8 sm:col-span-2'>
                          <label
                            htmlFor='firstName'
                            className={`block text-sm font-medium ${
                              !validFirstName ? "text-red-600" : "text-gray-700"
                            }`}>
                            First name*
                          </label>
                          <input
                            type='text'
                            name='firstName'
                            id='firstName'
                            maxLength='20'
                            className={`mt-1 ${
                              !validFirstName
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50 rounded-md`}
                          />
                          {!validFirstName && (
                            <p className='text-red-600 text-sm'>
                              First Name invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='lastName'
                            className='block text-sm font-medium text-gray-700'>
                            Last name
                          </label>
                          <input
                            type='text'
                            name='lastName'
                            id='lastName'
                            maxLength='20'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='customerType'
                            className={`block text-sm font-medium ${
                              !validCustomerType
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Customer Type*
                          </label>
                          <select
                            id='customerType'
                            name='customerType'
                            onChange={(e) => {
                              setCustomerType(e.target.value);
                            }}
                            className={`mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none ${
                              !validCustomerType
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } sm:text-sm disabled:bg-gray-100 disabled:opacity-50`}>
                            <option value=''>Select</option>
                            <option>Agent</option>
                            <option>Connector</option>
                            <option>Direct</option>
                            <option>Promoter</option>
                          </select>
                          {!validCustomerType && (
                            <p className='text-red-600 text-sm'>
                              Customer Type invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='crm'
                            className='block text-sm font-medium text-gray-700'>
                            CRM
                          </label>
                          {crmData?.length > 0 ? (
                            <select
                              id='crm'
                              name='crm'
                              onChange={(e) => {
                                setCRM(e.target.value);
                              }}
                              className='mt-1 block w-full py-2 px-3 border disabled:bg-gray-100 disabled:opacity-50 bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option>Select</option>
                              {crmData.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.fullname
                                    ? item.fullname
                                    : item.firstname}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <select
                              id='crm'
                              name='crm'
                              className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option>Loading</option>
                            </select>
                          )}
                        </div>

                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='serviceTypeId'
                            className={`block text-sm font-medium ${
                              !validCustomerType
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Service*
                          </label>
                          <select
                            id='serviceTypeId'
                            name='serviceTypeId'
                            onChange={(e) => {
                              updateSubServiceOptions(e.target.value);
                              setServiceTypeValue(
                                e.target.selectedOptions[0].text,
                              );
                            }}
                            defaultValue=''
                            className={`mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none ${
                              !validCustomerType
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } sm:text-sm`}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {serviceOptionsData.length > 0 ? (
                              serviceOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                          {!validCustomerType && (
                            <p className='text-red-600 text-sm'>
                              Service invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='subServiceTypeId'
                            className={`block text-sm font-medium ${
                              !validCustomerType
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Sub Service*
                          </label>
                          <select
                            id='subServiceTypeId'
                            name='subServiceTypeId'
                            className={`mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none ${
                              !validCustomerType
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } sm:text-sm`}
                            defaultValue=''
                            onChange={(event) => {
                              setSubServiceTypeValue(
                                event.target.selectedOptions[0].text,
                              );
                              setSubServiceLabel(
                                event.target.options[
                                  event.target.selectedIndex
                                ].text.toLowerCase(),
                              );
                            }}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {subServiceOptionsData.length > 0 ? (
                              subServiceOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                          {!validCustomerType && (
                            <p className='text-red-600 text-sm'>
                              Subservice invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='propertyOptionId'
                            className={`block text-sm font-medium ${
                              !validCustomerType
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Property*
                          </label>
                          <select
                            id='propertyOptionId'
                            name='propertyOptionId'
                            onChange={(e) => {
                              setPropertyOption(e.target.value);
                              updateSubPropertyOptions(e.target.value);
                            }}
                            defaultValue=''
                            className={`mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm`}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {propertyOptionsData.length > 0 ? (
                              propertyOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                          {!validCustomerType && (
                            <p className='text-red-600 text-sm'>
                              Property invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='subPropertyOptionId'
                            className={`block text-sm font-medium ${
                              !validCustomerType
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Sub Property*
                          </label>
                          <select
                            id='subPropertyOptionId'
                            name='subPropertyOptionId'
                            defaultValue=''
                            onChange={(e) => {
                              setSubPropertyOption(e.target.value);
                            }}
                            className={`mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none ${
                              !validCustomerType
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } sm:text-sm`}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {subPropertyOptionsData.length > 0 ? (
                              subPropertyOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                          {!validCustomerType && (
                            <p className='text-red-600 text-sm'>
                              Sub-Property invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='location'
                            className='block text-sm font-medium text-gray-700'>
                            Location
                          </label>
                          <input
                            type='text'
                            name='location'
                            id='location'
                            maxLength='30'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='budget'
                            className='block text-sm font-medium text-gray-700'>
                            Budget (INR)
                          </label>
                          <input
                            type='tel'
                            name='budget'
                            id='budget'
                            maxLength='5'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor='budget'
                            className='block text-sm font-medium text-gray-700'>
                            &nbsp;
                          </label>
                          <select
                            id='budgetfactor'
                            name='budgetfactor'
                            className={`mt-1 ${
                              !validBudgetfactor
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}>
                            <option value=''>Select</option>
                            <option value='1000'>Thousands</option>
                            <option value='100000'>Lakhs</option>
                            <option value='10000000'>Crores</option>
                          </select>
                          {!validBudgetfactor && (
                            <p className='text-red-600 text-sm'>
                              Factor invalid
                            </p>
                          )}
                        </div>

                        <div className={`col-span-6 sm:col-span-2`}>
                          <label
                            htmlFor='landExtent'
                            className={`block text-sm font-medium ${
                              !validLandExtent
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Land Extent*
                          </label>
                          <input
                            type='tel'
                            name='landExtent'
                            id='landExtent'
                            maxLength='20'
                            className={`mt-1 ${
                              !validLandExtent
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                          {!validLandExtent && (
                            <p className='text-red-600 text-sm'>
                              Land Extent required
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='units'
                            className={`block text-sm font-medium ${
                              !validUnits ? "text-red-600" : "text-gray-700"
                            }`}>
                            Units*
                          </label>
                          <select
                            id='units'
                            name='units'
                            className={`mt-1 ${
                              !validUnits
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}>
                            <option value=''>Select</option>
                            <option value='sq. ft'>sq. ft</option>
                            <option value='sq. metre'>sq. metre</option>
                            <option value='sq. yards'>sq. yards</option>
                            <option value='acres'>acres</option>
                            <option value='cents'>cents</option>
                            <option value='ground'>ground</option>
                            <option value='hectares'>hectares</option>
                          </select>
                          {!validUnits && (
                            <p className='text-red-600 text-sm'>
                              Units invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor='bhk'
                            className='block text-sm font-medium text-gray-700'>
                            BHK#
                          </label>
                          <input
                            type='tel'
                            name='bhk'
                            id='bhk'
                            maxLength='2'
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm read-only:bg-gray-100 read-only:opacity-50  rounded-md'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-11'>
                          <label
                            htmlFor='serviceInformation'
                            className='block text-sm font-medium text-gray-700'>
                            Service Information*
                          </label>
                          <textarea
                            id='serviceInformation'
                            name='serviceInformation'
                            rows={3}
                            className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-sm border  rounded-md'
                            placeholder=''
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      <div className='mt-10 lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Additional Information
                          </h2>
                        </div>
                      </div>

                      <div className='mt-3 sm:mt-4 grid grid-cols-12 gap-6'>
                        <div className='col-span-7 sm:col-span-2'>
                          <label
                            htmlFor='leadType'
                            className='block text-sm font-medium text-gray-700'>
                            Lead Type*
                          </label>
                          <select
                            id='leadType'
                            name='leadType'
                            onChange={(e) => {
                              setLeadType(e.target.value);
                            }}
                            className='mt-1 block w-full py-2 px-3 border  bg-gray-50 rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option>Individual</option>
                            <option>Corporate</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='channel'
                            className={`block text-sm font-medium ${
                              !validChannel ? "text-red-600" : "text-gray-700"
                            }`}>
                            Channel*
                          </label>
                          <select
                            id='channel'
                            name='channel'
                            className={`mt-1 ${
                              !validChannel
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm rounded-md`}
                            onChange={(event) => {
                              setChannel(event.target.value);
                              if (
                                ["Reference", "Agent", "Others"].includes(
                                  event.target.value,
                                )
                              ) {
                                setReferenceChannel(true);
                                setWebsiteChannel(false);
                              } else if (event.target.value === "Website") {
                                setReferenceChannel(false);
                                setWebsiteChannel(true);
                              } else {
                                setReferenceChannel(false);
                                setWebsiteChannel(false);
                              }
                            }}>
                            <option value=''>Select</option>
                            <option value='99 acres'>99 acres</option>
                            <option value='Agent'>Agent</option>
                            <option value='BNI'>BNI</option>
                            <option value='Common Floor'>Common Floor</option>
                            <option value='Email'>Email</option>
                            <option value='Facebook'>Facebook</option>
                            <option value='Fieldwork'>Fieldwork</option>
                            <option value='Just Dial'>Just Dial</option>
                            <option value='Knowlarity'>Knowlarity</option>
                            <option value='Magic Bricks'>Magic Bricks</option>
                            <option value='Net Search'>Net Search</option>
                            <option value='Newspaper Ad'>Newspaper Ad</option>
                            <option value='Old Client'>Old Client</option>
                            <option value='Online Marketing'>
                              Online Marketing
                            </option>
                            <option value='On Site Board'>On Site Board</option>
                            <option value='Reference'>Reference</option>
                            <option value='Walk-in'>Walk-in</option>
                            <option value='Website'>Website</option>
                            <option>Others</option>
                          </select>
                          {!validChannel && (
                            <p className='text-red-600 text-sm'>
                              Enquiry Channel invalid
                            </p>
                          )}
                        </div>
                        {referenceChannel ? (
                          <div className={`col-span-12 sm:col-span-3`}>
                            <label
                              htmlFor='referenceName'
                              className={`block text-sm font-medium ${
                                !validReferenceName
                                  ? "text-red-600"
                                  : "text-gray-700"
                              }`}>
                              {channel === "Reference"
                                ? "Reference Name"
                                : channel === "Agent"
                                ? "Agent Name"
                                : "Others"}
                            </label>
                            <input
                              type='text'
                              name='referenceName'
                              id='referenceName'
                              maxLength='50'
                              className={`mt-1 ${
                                !validReferenceName
                                  ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                  : "focus:ring-yellow-2 focus:border-yellow-2"
                              }  block w-full shadow-sm sm:text-sm  rounded-md`}
                            />
                            {!validReferenceName && (
                              <p className='text-red-600 text-sm'>
                                Reference Name required
                              </p>
                            )}
                          </div>
                        ) : websiteChannel ? (
                          <div className={`col-span-12 sm:col-span-3`}>
                            <label
                              htmlFor='websiteLink'
                              className={`block text-sm font-medium ${
                                !validWebsiteLink
                                  ? "text-red-600"
                                  : "text-gray-700"
                              }`}>
                              Website Link
                            </label>
                            <input
                              type='text'
                              name='websiteLink'
                              id='websiteLink'
                              maxLength='70'
                              className={`mt-1 ${
                                !validWebsiteLink
                                  ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                  : "focus:ring-yellow-2 focus:border-yellow-2"
                              }  block w-full shadow-sm sm:text-sm  rounded-md`}
                            />
                            {!validWebsiteLink && (
                              <p className='text-red-600 text-sm'>
                                Website Link required
                              </p>
                            )}
                          </div>
                        ) : (
                          <div className='col-span-12 sm:col-span-6'></div>
                        )}
                        {subServiceLabel === "buy" ? (
                          <div className={`col-span-12 sm:col-span-2`}>
                            <label
                              htmlFor='purposeOfBuying'
                              className={`block text-sm font-medium ${"text-gray-700"}`}>
                              Purpose of Buying*
                            </label>
                            <select
                              id='purposeOfBuying'
                              name='purposeOfBuying'
                              className={`mt-1 ${"focus:ring-yellow-2 focus:border-yellow-2"}  block w-full shadow-sm sm:text-sm  rounded-md`}>
                              <option value='Own Use'>Own Use</option>
                              <option value='Investment'>Investment</option>
                            </select>
                          </div>
                        ) : (
                          <></>
                        )}

                        <div className='col-span-12 sm:col-span-6'>
                          <label
                            htmlFor='backgroundInformation'
                            className='block text-sm font-medium text-gray-700'>
                            Background Information
                          </label>
                          <textarea
                            id='backgroundInformation'
                            name='backgroundInformation'
                            rows={3}
                            className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-sm border  rounded-md'
                            placeholder=''
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      {leadType === "Corporate" && (
                        <>
                          <div className='mt-5 lg:flex lg:items-center justify-between'>
                            <div className='flex-1 min-w-0 px-0 lg:px-0'>
                              <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                                Corporate Lead Information
                              </h2>
                            </div>
                          </div>
                          <div className='mt-3 sm:mt-2 grid grid-cols-12 gap-6'>
                            <div className={`col-span-12 sm:col-span-3`}>
                              <label
                                htmlFor='corporateLeadCompanyName'
                                className={`block text-sm font-medium ${
                                  !validCompanyName
                                    ? "text-red-600"
                                    : "text-gray-700"
                                }`}>
                                Company Name*
                              </label>
                              <input
                                type='text'
                                name='corporateLeadCompanyName'
                                id='corporateLeadCompanyName'
                                maxLength='20'
                                className={`mt-1 ${
                                  !validCompanyName
                                    ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                    : "focus:ring-yellow-2 focus:border-yellow-2"
                                }  block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                              {!validCompanyName && (
                                <p className='text-red-600 text-sm'>
                                  Company Name required
                                </p>
                              )}
                            </div>
                            <div className={`col-span-12 sm:col-span-2`}>
                              <label
                                htmlFor='corporateLeadDesignation'
                                className={`block text-sm font-medium text-gray-700`}>
                                Designation
                              </label>
                              <input
                                type='text'
                                name='corporateLeadDesignation'
                                id='corporateLeadDesignation'
                                maxLength='50'
                                className={`mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                            </div>
                            <div className={`col-span-12 sm:col-span-5`}>
                              <label
                                htmlFor='corporateLeadCompanyAddress'
                                className={`block text-sm font-medium ${
                                  !validCompanyAddress
                                    ? "text-red-600"
                                    : "text-gray-700"
                                }`}>
                                Company Address
                              </label>
                              <input
                                type='text'
                                name='corporateLeadCompanyAddress'
                                id='corporateLeadCompanyAddress'
                                maxLength='50'
                                className={`mt-1 ${
                                  !validCompanyAddress
                                    ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                    : "focus:ring-yellow-2 focus:border-yellow-2"
                                }  block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                              {!validCompanyAddress && (
                                <p className='text-red-600 text-sm'>
                                  Company Address required
                                </p>
                              )}
                            </div>
                            <div className={`col-span-12 sm:col-span-2`}>
                              <label
                                htmlFor='corporateLeadPhone'
                                className={`block text-sm font-medium ${
                                  !validCompanyPhone
                                    ? "text-red-600"
                                    : "text-gray-700"
                                }`}>
                                Company Phone
                              </label>
                              <input
                                type='tel'
                                name='corporateLeadPhone'
                                id='corporateLeadPhone'
                                maxLength='15'
                                className={`mt-1 ${
                                  !validCompanyPhone
                                    ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                    : "focus:ring-yellow-2 focus:border-yellow-2"
                                }  block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                              {!validCompanyPhone && (
                                <p className='text-red-600 text-sm'>
                                  Company Phone required
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {((serviceTypeValue
                        ?.toLowerCase()
                        .includes("brokerage") &&
                        subServiceTypeValue?.toLowerCase().includes("sell")) ||
                        (serviceTypeValue?.toLowerCase().includes("rental") &&
                          subServiceTypeValue
                            ?.toLowerCase()
                            .includes("landlord"))) && (
                        <>
                          <div className='mt-10 lg:flex lg:items-center justify-between'>
                            <div className='flex-1 min-w-0 px-0 lg:px-0'>
                              <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                                Property Information
                              </h2>
                            </div>
                          </div>
                          <div className='grid mt-2 grid-cols-12 gap-2'>
                            <div className='col-span-12 rounded-md'>
                              {markerCoordinates.lat ? (
                                <GmapsComponent
                                  zoom={10}
                                  position={markerCoordinates}
                                  draggableMarker={true}
                                  onPositionChanged={updatedMarkerPosition}
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                            <div className='col-span-6 sm:col-span-2'>
                              <label
                                htmlFor='longitude'
                                className={`block text-sm font-medium ${"text-gray-700"}`}>
                                Longitude
                              </label>
                              <input
                                type='number'
                                name='longitude'
                                id='longitude'
                                maxLength='15'
                                className={`mt-0 ${"focus:ring-yellow-2 focus:border-yellow-2"}  block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                            </div>
                            <div className='col-span-6 sm:col-span-2'>
                              <label
                                htmlFor='latitude'
                                className={`block text-sm font-medium ${"text-gray-700"}`}>
                                Latitude
                              </label>
                              <input
                                type='number'
                                name='latitude'
                                id='latitude'
                                maxLength='15'
                                className={`mt-0 ${"focus:ring-yellow-2 focus:border-yellow-2"}  block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                            </div>
                            <div className='col-span-12 sm:col-span-2'>
                              <label
                                htmlFor='pifLocation'
                                className='block text-sm font-medium text-gray-700'>
                                Location
                              </label>
                              <Multiselect
                                className={`mt-0 focus:ring-0 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-xs`}
                                options={propertyLocationsData}
                                selectedValues={pifLocationsSelectedData}
                                onSelect={(selectedList, selectedItem) => {
                                  selectedList.map((item) => {
                                    delete item["validflag"];
                                    delete item["createdAt"];
                                    delete item["updatedAt"];
                                  });
                                  setPifLocationsSelectedData(selectedList);
                                  const pifLocationIds = [];
                                  selectedList.map((item) => {
                                    pifLocationIds.push(item._id);
                                  });
                                  setPIFLocations(pifLocationIds);
                                }}
                                onRemove={(selectedList, removedItem) => {
                                  selectedList.map((item) => {
                                    delete item["validflag"];
                                    delete item["createdAt"];
                                    delete item["updatedAt"];
                                  });
                                  setPifLocationsSelectedData(selectedList);
                                  const pifLocationIds = [];
                                  selectedList.map((item) => {
                                    pifLocationIds.push(item._id);
                                  });
                                  setPIFLocations(pifLocationIds);
                                }}
                                displayValue='name'
                                style={{
                                  chips: {
                                    background: "#dea302",
                                    borderRadius: "2pt",
                                  },
                                  multiselectContainer: {
                                    color: "#000",
                                  },
                                  inputField: {
                                    "font-size": "13px",
                                    padding: "3px 5px 3px 7px",
                                    width: "100%",
                                    border: "none",
                                    boxShadow: "none",
                                  },
                                  searchBox: {
                                    border: "solid 0.5px #777",
                                    "font-size": "5px",
                                    padding: "1px",
                                    background: "#fff",
                                  },
                                }}
                              />
                            </div>
                            <div className='col-span-12 sm:col-span-2'>
                              <label
                                htmlFor='frontage'
                                className='block text-sm font-medium text-gray-700'>
                                Frontage
                              </label>
                              <input
                                type='text'
                                name='frontage'
                                id='frontage'
                                maxLength='100'
                                className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                              />
                            </div>
                            <div className='col-span-6 sm:col-span-1'>
                              <label
                                htmlFor='facing'
                                className='block text-sm font-medium text-gray-700'>
                                Facing
                              </label>
                              <select
                                id='facing'
                                name='facing'
                                className='mt-0 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                                <option value=''>Select</option>
                                <option value='North'>North</option>
                                <option value='South'>South</option>
                                <option value='West'>West</option>
                                <option value='East'>East</option>
                                <option value='North-East'>North-East</option>
                                <option value='North-West'>North-West</option>
                                <option value='South-East'>South-East</option>
                                <option value='South-West'>South-West</option>
                                <option value='North and South'>
                                  North and South
                                </option>
                                <option value='East and West'>
                                  East and West
                                </option>
                                <option value='Others'>Others</option>
                              </select>
                            </div>
                            <div className='col-span-6 sm:col-span-2'>
                              <label
                                htmlFor=''
                                className='block text-sm font-medium text-gray-700'>
                                Parking Available
                              </label>
                              <div className='flex mt-2'>
                                <label className='ml-7 relative items-center cursor-pointer'>
                                  <input
                                    type='checkbox'
                                    className='sr-only peer '
                                    checked={parkingAvailable}
                                    readOnly
                                  />
                                  <div
                                    onClick={() => {
                                      setparkingAvailable(!parkingAvailable);
                                    }}
                                    className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                                </label>
                              </div>
                            </div>
                            <div className='col-span-6 sm:col-span-1'>
                              <label
                                htmlFor='buildingFloors'
                                className='block text-sm font-medium text-gray-700'>
                                Building Floors
                              </label>
                              <select
                                id='buildingFloors'
                                name='buildingFloors'
                                className='mt-0 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                                <option value=''>Select</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                                <option value='5'>5</option>
                                <option value='6'>6</option>
                                <option value='7'>7</option>
                                <option value='8'>8</option>
                                <option value='9'>9</option>
                                <option value='10'>10</option>
                              </select>
                            </div>
                            <div className='col-span-12 sm:col-span-10'>
                              <label
                                htmlFor=''
                                className='block text-sm font-medium text-gray-700'>
                                Property Images
                              </label>
                              <div className='grid grid-cols-6 gap-4'>
                                {propertyImageAttachments.length !== 0 ? (
                                  propertyImageAttachments.map((item) => (
                                    <div
                                      className='col-span-3 sm:col-span-1'
                                      key={item.blobName}>
                                      <PropertyThumbnail
                                        thumbnail={item}
                                        blobContainerName={blobContainerName}
                                      />
                                      <div
                                        className='-mt-2 pt-1 cursor-pointer'
                                        onClick={(e) => {
                                          e.preventDefault();
                                          removePropertyImageAttachments(
                                            item.blobName,
                                          );
                                        }}>
                                        <img
                                          className={`h-5 w-5`}
                                          src='/assets/icons/trash-filled.png'
                                          alt='X'
                                          title='Remove attachment'
                                        />
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <></>
                                )}
                                {propertyImageAttachments.length <= 5 && (
                                  <div className='col-span-3 sm:col-span-1'>
                                    <FileUploader
                                      handleChange={uploadPropertyImage}
                                      name='propertyImage'
                                      multiple={true}
                                      label='Upload or Drop files to move enquiry to Service ticket'
                                      children={
                                        <div className='flex p-2 justify-center border-2 border-yellow-2'>
                                          <img
                                            src='/assets/images/add_property_image.jpg'
                                            alt='Property Image'
                                            referrerPolicy='no-referrer'
                                            className='h-32'
                                          />
                                        </div>
                                      }
                                      types={["JPG", "PNG"]}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div
                          className={`flex-1 min-w-0 px-0 lg:px-0 ${
                            requestLoading ? "opacity-70" : "opacity:100"
                          }`}>
                          <Link
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(-1);
                              if (!requestLoading) navigate(-1);
                            }}
                            className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                            Back
                          </Link>
                          {!requestLoading ? (
                            <button
                              id='submitBtn'
                              type='submit'
                              className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              SAVE
                            </button>
                          ) : (
                            <button
                              className='animate-bounce ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                              disabled={true}>
                              Processing...
                            </button>
                          )}
                        </div>
                      </div>
                      <div className='sm: py-2'></div>
                    </div>
                  </div>
                </form>
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'></div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default EnquiryCreate;
